import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { getDeviceTreeApi } from '@blade-sxp/record-center/api/index';
let PortaitLibray = class PortaitLibray extends Vue {
    value;
    curValue = [];
    options = [];
    props = { multiple: true, value: 'treeId', label: 'name', emitPath: false };
    onValue(nv) {
        this.curValue = this.value;
    }
    handleChange() {
        this.$emit('update:value', this.curValue);
        this.$emit('change', this.curValue);
        console.log('handleChange device', this.curValue);
    }
    init() {
        this.getOption();
    }
    dealDeviceTree(tree) {
        const dep = (node) => {
            if (node?.children?.length > 0) {
                node.children?.forEach((i) => dep(i));
            }
            else {
                delete node.children;
            }
            return node;
        };
        tree = tree.map((i) => dep(i));
        return tree;
    }
    async getOption() {
        try {
            const res = await getDeviceTreeApi();
            this.options = this.dealDeviceTree(res?.tree ?? []);
            console.log('getDeviceTreeApi res', res?.tree, ' this.options', this.options);
        }
        catch (e) {
            console.log(e);
        }
    }
    created() {
        this.init();
    }
};
__decorate([
    Prop()
], PortaitLibray.prototype, "value", void 0);
__decorate([
    Watch('value', { deep: true, immediate: true })
], PortaitLibray.prototype, "onValue", null);
PortaitLibray = __decorate([
    Component({
        name: 'device-tree',
        i18n: {
            messages: {
                zh: {
                    placeholder: 'Device Name',
                },
                en: {
                    placeholder: 'Device Name',
                },
            },
        },
    })
], PortaitLibray);
export default PortaitLibray;
